import React from 'react'
import StraightenIcon from '@mui/icons-material/Straighten'
import ScaleIcon from '@mui/icons-material/Scale'
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat'
import ViewInArIcon from '@mui/icons-material/ViewInAr'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import SpeedIcon from '@mui/icons-material/Speed'
import CompressIcon from '@mui/icons-material/Compress'
import BoltIcon from '@mui/icons-material/Bolt'
import CropIcon from '@mui/icons-material/Crop'
import PowerIcon from '@mui/icons-material/Power'
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap'
import ArchitectureIcon from '@mui/icons-material/Architecture'
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt'
import FlashOnIcon from '@mui/icons-material/FlashOn'
import GraphicEqIcon from '@mui/icons-material/GraphicEq'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleRadiation, faBiohazard } from '@fortawesome/free-solid-svg-icons'

import { Measure } from '../types'
import { MeasureDataContext } from '../contexts/MeasureDataProvider'

interface MeasureIconProps {
  measure: Measure
  color?: string
}

const TabMeasureIcon: React.FC<MeasureIconProps> = (props) => {
  const { allMeasures } = React.useContext(MeasureDataContext)
  const iconStyle = { mr: 1, ...(props.color ? { color: props.color } : {}) }

  switch (props.measure.codeName) {
    case allMeasures.length.codeName:
      return (<StraightenIcon sx={iconStyle} />)
    case allMeasures.volume.codeName:
      return (<ViewInArIcon sx={iconStyle} />)
    case allMeasures.temperature.codeName:
      return (<DeviceThermostatIcon sx={iconStyle} />)
    case allMeasures.weight.codeName:
      return (<ScaleIcon sx={iconStyle} />)
    case allMeasures.area.codeName:
      return (<CropIcon sx={iconStyle} />)
    case allMeasures.time.codeName:
      return (<AccessTimeIcon sx={iconStyle} />)
    case allMeasures.speed.codeName:
      return (<SpeedIcon sx={iconStyle} />)
    case allMeasures.pressure.codeName:
      return (<ZoomInMapIcon sx={iconStyle} />)
    case allMeasures.energy.codeName:
      return (<BoltIcon sx={iconStyle} />)
    case allMeasures.power.codeName:
      return (<PowerIcon sx={iconStyle} />)
    case allMeasures.force.codeName:
      return (<CompressIcon sx={iconStyle} />)
    case allMeasures.angle.codeName:
      return (<ArchitectureIcon sx={iconStyle} />)
    case allMeasures.electricCurrent.codeName:
      return (<OfflineBoltIcon sx={iconStyle} />)
    case allMeasures.electricPotential.codeName:
      return (<FlashOnIcon sx={iconStyle} />)
    case allMeasures.frequency.codeName:
      return (<GraphicEqIcon sx={iconStyle} />)
    case allMeasures.dataStorage.codeName:
      return (<DescriptionOutlinedIcon sx={iconStyle} />)
    case allMeasures.bandwidth.codeName:
      return (<ImportExportIcon sx={iconStyle} />)
    case allMeasures.fuelConsumption.codeName:
      return (<LocalGasStationIcon sx={iconStyle} />)
    case allMeasures.radioactiveDecay.codeName:
      return (<FontAwesomeIcon icon={faCircleRadiation} style={{ marginRight: '8px', fontSize: '1.2rem', color: props.color }} />)
    case allMeasures.radioactiveEquivalentDose.codeName:
      return (<FontAwesomeIcon icon={faBiohazard} style={{ marginRight: '8px', fontSize: '1.2rem', color: props.color }} />)
  }
  return <></>
}

export default TabMeasureIcon
